import { Button, ContentCard, Grid, Stack } from '@forwardflow/ui-v2'
import { ArrowLeftMdIcon } from '@forwardflow/icons'
import { motion } from 'framer-motion'
import cn from 'classnames'
import { ChevronRightIcon } from '@forwardflow/icons'
import { PRIMARY_FILTER_OPTIONS } from '../constants'
import { useCampaignFilterContext } from '../hooks'
import { TLeadType } from '../interfaces'

export const PrimaryFilter = ({
   setStep,
   selectedPrimaryFilter,
   setSelectedPrimaryFilter,
}: {
   setStep: (step: number) => void
   selectedPrimaryFilter: string | null
   setSelectedPrimaryFilter: (selectedPrimaryFilter: string | null) => void
}) => {
   const { setFirstFilterCriteria } = useCampaignFilterContext()
   return (
      <>
      <ContentCard className="space-y-5">
         <div>
            <p className="text-white font-semibold text-lg mb-1">
               Which leads do you want Forward Flow to work on first?
            </p>
            <p className="text-white/50 text-sm">
               Choose a source, pond, stage, or tag to define your target group.
            </p>
         </div>
         <Stack gap={10}>
            {PRIMARY_FILTER_OPTIONS.map((option) => {
               const isSelected = selectedPrimaryFilter === option.value
               return (
                  <motion.button
                     whileHover={{ scale: 1.01 }}
                     whileTap={{ scale: 0.99 }}
                     onClick={() => {
                        if (!isSelected) {
                           setFirstFilterCriteria({
                              field: option.value as TLeadType,
                              value: [],
                              logic: 'AND',
                              operator: 'CONTAINS_ANY',
                           })
                        }
                        setSelectedPrimaryFilter(option.value)
                        setStep(3)
                     }}
                     key={option.value}
                     className={cn(
                        'rounded-lg px-4 py-3.5 flex items-center gap-4 text-left transition-colors duration-150 border',
                        isSelected
                           ? 'bg-[#A684FF]/20 border-[#A684FF]/40'
                           : 'bg-white/[0.03] border-white/[0.06] hover:bg-white/[0.06] hover:border-white/10'
                     )}
                  >
                     <div
                        className={cn(
                           'rounded-lg w-10 h-10 flex items-center justify-center shrink-0 transition-colors',
                           isSelected
                              ? 'bg-[#A684FF]/20'
                              : 'bg-white/[0.06]'
                        )}
                     >
                        {option.icon}
                     </div>
                     <div className="flex-1 min-w-0">
                        <p className="text-white font-medium text-[15px]">
                           {option.label}
                        </p>
                        <p className="text-white/40 text-xs">
                           {option.description}
                        </p>
                     </div>
                     <ChevronRightIcon
                        width={16}
                        className={cn(
                           'shrink-0 transition-opacity',
                           isSelected
                              ? 'text-[#A684FF] opacity-100'
                              : 'text-white/30 opacity-0 group-hover:opacity-100'
                        )}
                     />
                  </motion.button>
               )
            })}
         </Stack>
      </ContentCard>
      <Grid>
         <Grid.Col span={3}>
            <Button
               variant="secondary"
               className="w-full"
               onClick={() => setStep(1)}
            >
               <ArrowLeftMdIcon width={12} /> Back
            </Button>
         </Grid.Col>
      </Grid>
      </>
   )
}
